export const environment = {
  backendUrl: 'https://uat.api.comex-mckinnon.ie',
};
